export default __webpack_public_path__ + "static/media/placeholdercar1.cb0274bd.png";